(function () {
    'use strict';

    angular
        .module('sod.helper')
        .directive('rmsCarousel', rmsCarousel);

    function rmsCarousel(lodash, $timeout, $compile) {
        return {
            restrict: 'E',
            template: '<div class="unite-gallery" ng-class="options.rms_class"></div>',
            scope: {
                'options': '=?',
                'items': '=?',
            },
            link: {
                post: function (scope, elem) {
                    const isGalleryAwards = scope.options.elem_id === 'gallery-awards';
                    const isGallerySecondary = scope.options.elem_id === 'gallery-secondary';
                    const isGalleryVideos = scope.options.elem_id === 'gallery_videos';

                    var options = angular.copy(scope.options) || {
                        gallery_skin: 'alexis',
                        slider_bullets_skin: 'alexis',
                    };
                    options = determineCenterMode(options, scope.items);

                    if (isGalleryAwards || isGallerySecondary) {
                        var slick = elem
                            .find('.unite-gallery')
                            .attr('id', scope.options.elem_id || 'slick-gallery-1')
                            .html(scope.galleryItemHtml)
                            .slick(options);

                        scope.$on('$destroy', (function (scope) {
                            return function () {
                                $('#' + scope.options.elem_id).slick('unslick');
                            };
                        })(scope));
                    } else {
                        var ug = elem
                            .find('.unite-gallery')
                            .attr('id', scope.options.elem_id || 'unite-gallery-1')
                            .html(scope.galleryItemHtml)
                            .unitegallery(options);

                        scope.$on('$destroy', function () {
                            ug.destroy();
                        });

                        function sodSetUniteGallerySize(scope, options, ug) {
                            const itemCount = scope.items.length;
                            const padding = options.carousel_padding || 10;
                            const outerWrapperWidth = $('#gallery_videos').width();
                            const tileWidth = options.tile_width + (padding * 2);
                            const tileCount = Math.floor(outerWrapperWidth / tileWidth);

                            if (itemCount <= tileCount) {
                                const width = itemCount * tileWidth - padding;
                                const left = (outerWrapperWidth - width) / 2;
                                $('#' + scope.options.elem_id + ' .ug-carousel-wrapper')
                                    .css('width', width + 'px')
                                    .css('left', left + 'px');

                                $('#' + scope.options.elem_id + ' .ug-pause-icon').click();
                                $('#' + scope.options.elem_id + ' .ug-tile-navigation-wrapper').css('display', 'none');
                            }
                        }

                        if (isGalleryVideos) {
                            sodSetUniteGallerySize(scope, options, ug);

                            ug.on('resize', (function (scope, options, ug) {
                                return function () {
                                    width
                                    sodSetUniteGallerySize(scope, options, ug);
                                };
                            })(scope, options, ug));
                        }
                    }

                    var compileScope = scope;
                    $compile(elem.contents())(compileScope);
                },
                pre: function (scope) {
                    const isGalleryAwards = scope.options.elem_id === 'gallery-awards';
                    const isGallerySecondary = scope.options.elem_id === 'gallery-secondary';
                    var galleryItems = !lodash.isEmpty(scope.items) ? scope.items : lodash.get(scope.options, 'gallery_items', []);

                    if (isGalleryAwards) {
                        scope.galleryItemHtml = galleryItems.map(function (item) {
                            const galleryContentWidth = lodash.get(scope, 'options.width', 160);
                            const galleryContentWidthPx = galleryContentWidth + 'px';

                            return [
                                '<div class="gallery-award">',
                                '<div class="gallery-award-header">' + (item.alt || '') + '</div>',
                                '<div style="margin: auto; text-align: center;">',
                                '<div class="gallery-award-image-wrapper">',
                                '<div style="margin: auto; width: ' + galleryContentWidthPx + '; height: ' + galleryContentWidthPx + '; background-repeat: no-repeat; background-position: center; background-size: contain;background-image: url(\'' + item.src + '\')"></div>',
                                '</div>',
                                '</div>',
                                '<div class="gallery-award-caption">' + (item.description || '') + '</div>',
                                '</div>'
                            ].join('');
                        }).join('');
                    } else if (isGallerySecondary) {
                        scope.galleryItemHtml = galleryItems.map(function (item) {
                            return [
                                '<div class="gallery-award secondary">',
                                '<div css-width-based-on-parent style="margin: auto; width: 240px; height: 185px; background-repeat: no-repeat; background-position: center; background-size: contain;background-image: url(\'' + item.src + '\')"></div>',
                                '<div style="font-size: 1.54em; padding: 5px 0;" class="text-bold text-center emphasis-header">' + (item.title || '') + '</div>',
                                '<div style="font-size: 1.08em; padding: 5px 0;">' + (item.description || '') + '</div>',
                                '</div>'
                            ].join('');
                        }).join('');
                    } else {
                        scope.galleryItemHtml = galleryItems.map(function (item) {
                            switch (item.type) {
                                case 'html5video':
                                case 'youtube':
                                case 'vimeo':
                                case 'soundcloud':
                                    return '<img data-type="' + item.type + '" ' + generateAttr(item) + ' />';
                                default:
                                    var template = '<img ' + generateAttr(item) + '/>';

                                    if (!lodash.isEmpty(item.link)) {
                                        template = "<a href='" + item.link + "' target='_blank'>" + template + "</a>"
                                    }
                                    return template;
                            }
                        }).join('');
                    }


                    function generateAttr(item) {
                        return lodash.toPairs(item).reduce(function (result, pair) {
                            var key = pair[0];
                            var value = pair[1];
                            if (key === 'type') {
                                return result;
                            }
                            if (['src', 'alt'].indexOf(key) >= 0) {
                                result.push(key + '="' + value + '"');
                                return result;
                            }

                            if (['image', 'videoid', 'description', 'videoogv', 'videowebm', 'videomp4', 'trackid'].indexOf(key) >= 0) {
                                if (key === 'description') {
                                    result.push('data-' + key + '="' + value.replace(/<[\/][^>]*>/gi, " ").replace(/<[^>]*>/gi, " ") + '"');
                                } else {
                                    result.push('data-' + key + '="' + value + '"');
                                }
                                return result;
                            }
                            return result;
                        }, []).join(' ');
                    }
                },
            }
        };

        function determineCenterMode(options, items) {
            var itemCount = (items || []).length;
            if (itemCount === 0) return options;

            var rootSlidesToShow = lodash.get(options, 'slidesToShow', -1);
            if (rootSlidesToShow > 0) {
                options = lodash.set(options, 'centerMode', itemCount >= rootSlidesToShow);
            }

            var responsiveSlidesToShow = lodash.get(options, 'settings.slidesToShow', -1);
            if (responsiveSlidesToShow > 0) {
                options = lodash.set(options, 'settings.centerMode', itemCount >= responsiveSlidesToShow);
            }

            var responsive = lodash.get(options, 'responsive', []);
            var updatedResponsive = lodash.reduce(responsive, function (updatedResponsive, oResponsive) {
                return updatedResponsive.concat([determineCenterMode(oResponsive, items)]);
            }, []);
            if (updatedResponsive.length > 0) {
                options = lodash.set(options, 'responsive', updatedResponsive);
            }

            return options;
        }

        // function determineSlidesToShow(options, items) {
        //     var itemCount = (items || []).length;
        //     if (itemCount === 0) return options;
        //
        //     var rootSlidesToShow = lodash.get(options, 'slidesToShow', -1);
        //     if (rootSlidesToShow >= 0) {
        //         if (itemCount < rootSlidesToShow) {
        //             options = lodash.set(options, 'slidesToShow', itemCount);
        //         }
        //     }
        //
        //     var responsiveSlidesToShow = lodash.get(options, 'settings.slidesToShow', -1);
        //     if (responsiveSlidesToShow >= 0) {
        //         if (itemCount < responsiveSlidesToShow) {
        //             options = lodash.set(options, 'settings.slidesToShow', itemCount);
        //         }
        //     }
        //
        //     var responsive = lodash.get(options, 'responsive', []);
        //     var updatedResponsive = lodash.reduce(responsive, function (updatedResponsive, oResponsive) {
        //         return updatedResponsive.concat([determineSlidesToShow(oResponsive, items)]);
        //     }, []);
        //     if (updatedResponsive.length > 0) {
        //         options = lodash.set(options, 'responsive', updatedResponsive);
        //     }
        //
        //     return options;
        // }
    }
})();